export enum VariableGroup {
  PARKING = 'PARKING',
  ALLOWANCE = 'ALLOWANCE',
}

export enum VariableMode {
  CURRENT = 'CURRENT',
  EDIT = 'EDIT',
}
